
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-206 -103 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 283.134l157.866 115.199L148.134 210.6 306 99.667H114l-64-192-64 192h-192L-48.133 210.6l-59.734 187.733z"}})])
          )
        }
      }
    